// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__2CwMy","author":"Table_author__1U2QF","authorImage":"Table_authorImage__1Tfdf","unreadRow":"Table_unreadRow__2ZMJZ"};